const companyStyle = {
  componentPanel: {
    marginTop: '50px',
  },
  leftHeading: {
    textAlign: 'left',
    marginTop: '20px',
    marginBottom: '20px',
  },
  fieldSpacing: {
    marginTop: '10px',
  },
}

export default companyStyle
